/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type GetStakingBannerInfoQueryVariables = Types.Exact<{
	filter?: Types.InputMaybe<Types.AssetConfigFilter>;
	order?: Types.InputMaybe<Array<Types.AssetConfigOrder> | Types.AssetConfigOrder>;
}>;

export type GetStakingBannerInfoQuery = {
	__typename?: "Query";
	assetConfig: {
		__typename?: "AssetConfigResponse";
		assets?: Array<{
			__typename?: "StakeableAsset";
			assetId: string;
			availability: string;
			yearlyInterest: number;
		}> | null;
	};
	balances: Array<{
		__typename?: "StakingBalance";
		asset: { __typename?: "StakeableAsset"; assetId: string };
		stakedAmount: { __typename?: "CurrencyAmount"; value: string };
	}>;
	lifetimeRewards: Array<{
		__typename?: "LifetimeRewards";
		asset: { __typename?: "StakeableAsset"; assetId: string };
		rewardsAmount: { __typename?: "Balance"; asset: { __typename?: "CurrencyAmount"; value: string } };
	}>;
};

export const GetStakingBannerInfoDocument = gql`
	query getStakingBannerInfo($filter: AssetConfigFilter, $order: [AssetConfigOrder!]) {
		assetConfig(filter: $filter, order: $order) {
			assets {
				assetId
				availability
				yearlyInterest
			}
		}
		balances {
			asset {
				assetId
			}
			stakedAmount {
				value
			}
		}
		lifetimeRewards {
			asset {
				assetId
			}
			rewardsAmount {
				asset {
					value
				}
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class GetStakingBannerInfoGQLService extends Apollo.Query<
	GetStakingBannerInfoQuery,
	GetStakingBannerInfoQueryVariables
> {
	document = GetStakingBannerInfoDocument;
	client = "staking";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
